import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import { __decorate } from "tslib";
import { Component } from 'intact-vue';
import template from './index.vdt';
import { useItems } from './useItems';
import { useSlide } from './useSlide';
import { bind } from '../utils';
import { useAutoplay } from './useAutoplay';
import { useConfigContext } from '../config';
export * from './item';
var typeDefs = {
  value: String,
  autoplay: [Number, Boolean],
  arrow: ['hover', 'always', 'never'],
  effect: ['slide', 'fade'],
  clonedAmount: Number
};
var defaults = function defaults() {
  return {
    arrow: 'hover',
    effect: 'slide',
    clonedAmount: 1
  };
};
export var Carousel = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Carousel, _Component);
  function Carousel() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.items = useItems();
    _this.slide = useSlide(_this.items.getItems, _this.items.getItemsWithCloned);
    _this.autoplay = useAutoplay(_this.next);
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Carousel.prototype;
  _proto.isActive = function isActive(value) {
    return this.get('value') === value;
  };
  _proto.getIndex = function getIndex() {
    var _context2,
      _this2 = this;
    return _findIndexInstanceProperty(_context2 = this.items.getItems()).call(_context2, function (item) {
      return item.children.get('value') === _this2.get('value');
    });
  };
  _proto.setIndex = function setIndex(index) {
    var item = this.items.getItems()[index];
    this.setValue(item);
    this.slide.translateToItem(item, null, null, false);
  };
  _proto.prev = function prev() {
    var index = this.getIndex();
    var items = this.items.getItems();
    var length = items.length;
    var newIndex = (index + length - 1) % length;
    var item = items[newIndex];
    this.setValue(item);
    this.slide.translateToItem(item, index, newIndex, true);
  };
  _proto.next = function next() {
    var index = this.getIndex();
    var items = this.items.getItems();
    var newIndex = (index + 1) % items.length;
    var item = items[newIndex];
    this.setValue(item);
    this.slide.translateToItem(item, index, newIndex, true);
  };
  _proto.setValue = function setValue(item) {
    var value = item.children.get('value');
    this.set({
      value: value
    });
  };
  return Carousel;
}(Component);
Carousel.template = template;
Carousel.typeDefs = typeDefs;
Carousel.defaults = defaults;
__decorate([bind], Carousel.prototype, "setIndex", null);
__decorate([bind], Carousel.prototype, "prev", null);
__decorate([bind], Carousel.prototype, "next", null);